<template>
  <carousel-wrapper
    :element-key="elementKey"
    :element-data="elementData"
    display-name="Short Videos"
    icon-name="icons videoshorts"
    :children="elementData.shortvideo" />
</template>

<script>
import CarouselWrapper from "@/components/card/CarouselWrapper";

export default {
  name: "ShortVideosContainer",
  props: {
    elementKey: String,
    elementData: Object,
  },
  components: {
    CarouselWrapper,
  },
};
</script>

<scss lang="scss" scoped>
</scss>
